import { useState } from "react";
import { BiSolidReport } from "react-icons/bi";
import { FiAlertCircle, FiFilter, FiX } from "react-icons/fi";
import * as XLSX from "xlsx";
import BotaoRelatorio from "../../../components/relatorios/BotaoRelatorio";
import CabecalhoRelatorio from "../../../components/relatorios/CabecalhoRelatorio";
import Cartao from "../../../components/relatorios/Cartao";
import EstadoVazio from "../../../components/relatorios/EstadoVazio";
import { api } from "../../../services/api";
import { exportarRelatorioPDF } from "../../../utils/relatorioPdf";

const RelatorioCadastros = () => {
  const [tipo, setTipo] = useState("animais");
  const [dados, setDados] = useState([]);
  const [showModal, setShowModal] = useState(false);
  const [carregando, setCarregando] = useState(false);
  const [erro, setErro] = useState("");

  const [filtros, setFiltros] = useState({
    numero_identificacao: "",
    lote_atual: "",
    especie: "",
    status: "",
    nome_lote: "",
    fazenda: "",
    nome_pasto: "",
    area_min: "",
    area_max: "",
    nome_fazenda: "",
    cidade: "",
    estado: "",
    nome_funcionario: "",
    cargo: "",
    nome_produto: "",
    categoria: "",
    modelo: "",
    fabricante: "",
    nome: "",
  });

  const handleChange = (e) => {
    setFiltros({ ...filtros, [e.target.name]: e.target.value });
  };

  const limparFiltros = () => {
    const limpos = {};
    Object.keys(filtros).forEach((k) => (limpos[k] = ""));
    setFiltros(limpos);
  };

  // ─── FILTROS POR TIPO ────────────────────────────────────────────────────────
  const getFiltrosPorTipo = () => {
    const inputCls =
      "px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-brand-green focus:border-transparent outline-none transition";
    const selectCls = inputCls + " bg-white";

    switch (tipo) {
      case "animais":
        return (
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-3">
            <input
              name="numero_identificacao"
              placeholder="Número de Identificação"
              value={filtros.numero_identificacao}
              onChange={handleChange}
              className={inputCls}
            />
            <input
              name="lote_atual"
              placeholder="Lote Atual"
              value={filtros.lote_atual}
              onChange={handleChange}
              className={inputCls}
            />
            {/* select com valores inteiros que batem com o campo SmallIntegerField */}
            <select
              name="especie"
              value={filtros.especie}
              onChange={handleChange}
              className={selectCls}
            >
              <option value="">Todas as Espécies</option>
              <option value="1">Bovino</option>
              <option value="2">Suíno</option>
              <option value="3">Caprino</option>
              <option value="4">Ovino</option>
              <option value="5">Aves</option>
            </select>
            {/* values com os códigos reais do modelo ('A', 'V', 'B', 'M', 'T') */}
            <select
              name="status"
              value={filtros.status}
              onChange={handleChange}
              className={selectCls}
            >
              <option value="">Todos os Status</option>
              <option value="A">Ativo</option>
              <option value="V">Vendido</option>
              <option value="B">Abatido</option>
              <option value="M">Morto</option>
              <option value="T">Transferido</option>
            </select>
          </div>
        );

      case "lotes":
        return (
          <div className="grid grid-cols-1 md:grid-cols-2 gap-3">
            <input
              name="nome_lote"
              placeholder="Nome do Lote"
              value={filtros.nome_lote}
              onChange={handleChange}
              className={inputCls}
            />
            <input
              name="fazenda"
              placeholder="Fazenda"
              value={filtros.fazenda}
              onChange={handleChange}
              className={inputCls}
            />
          </div>
        );

      case "pastos":
        return (
          <div className="grid grid-cols-1 md:grid-cols-3 gap-3">
            <input
              name="nome_pasto"
              placeholder="Nome do Pasto"
              value={filtros.nome_pasto}
              onChange={handleChange}
              className={inputCls}
            />
            <input
              name="area_min"
              placeholder="Área Mínima (ha)"
              type="number"
              value={filtros.area_min}
              onChange={handleChange}
              className={inputCls}
            />
            <input
              name="area_max"
              placeholder="Área Máxima (ha)"
              type="number"
              value={filtros.area_max}
              onChange={handleChange}
              className={inputCls}
            />
          </div>
        );

      case "fazendas":
        return (
          <div className="grid grid-cols-1 md:grid-cols-3 gap-3">
            <input
              name="nome_fazenda"
              placeholder="Nome da Fazenda"
              value={filtros.nome_fazenda}
              onChange={handleChange}
              className={inputCls}
            />
            <input
              name="cidade"
              placeholder="Cidade"
              value={filtros.cidade}
              onChange={handleChange}
              className={inputCls}
            />
            <input
              name="estado"
              placeholder="Estado"
              value={filtros.estado}
              onChange={handleChange}
              className={inputCls}
            />
          </div>
        );

      case "funcionarios":
        return (
          <div className="grid grid-cols-1 md:grid-cols-2 gap-3">
            <input
              name="nome_funcionario"
              placeholder="Nome do Funcionário"
              value={filtros.nome_funcionario}
              onChange={handleChange}
              className={inputCls}
            />
            <input
              name="cargo"
              placeholder="Cargo"
              value={filtros.cargo}
              onChange={handleChange}
              className={inputCls}
            />
          </div>
        );

      case "itens_estoque":
        return (
          <div className="grid grid-cols-1 md:grid-cols-2 gap-3">
            <input
              name="nome_produto"
              placeholder="Nome do Produto"
              value={filtros.nome_produto}
              onChange={handleChange}
              className={inputCls}
            />
            <input
              name="categoria"
              placeholder="Categoria"
              value={filtros.categoria}
              onChange={handleChange}
              className={inputCls}
            />
          </div>
        );

      case "maquinas":
        return (
          <div className="grid grid-cols-1 md:grid-cols-2 gap-3">
            <input
              name="modelo"
              placeholder="Modelo"
              value={filtros.modelo}
              onChange={handleChange}
              className={inputCls}
            />
            <input
              name="fabricante"
              placeholder="Fabricante"
              value={filtros.fabricante}
              onChange={handleChange}
              className={inputCls}
            />
          </div>
        );

      default:
        return (
          <div className="grid grid-cols-1 gap-3">
            <input
              name="nome"
              placeholder="Nome / Busca..."
              value={filtros.nome}
              onChange={handleChange}
              className={inputCls}
            />
          </div>
        );
    }
  };

  // ─── COLUNAS MAPEADAS POR TIPO ───────────────────────────────────────────────
  const getColunasConfig = () => {
    const configs = {
      animais: [
        { key: "id", label: "ID" },
        { key: "numero_identificacao", label: "Identificação" },
        { key: "nome", label: "Nome" },
        { key: "especie_nome", label: "Espécie" },
        { key: "raca_nome", label: "Raça" },
        { key: "sexo_display", label: "Sexo" },
        { key: "peso", label: "Peso (kg)" },
        { key: "status_display", label: "Status" },
        { key: "lote_atual_nome", label: "Lote Atual" },
      ],
      lotes: [
        { key: "id", label: "ID" },
        { key: "nome", label: "Nome" },
        { key: "fazenda_nome", label: "Fazenda" },
        { key: "fase_display", label: "Fase" },
        { key: "data_entrada", label: "Data Entrada" },
        { key: "data_saida_prevista", label: "Previsão Saída" },
        { key: "peso_objetivo", label: "Peso Obj. (kg)" },
        { key: "gmd_previsto", label: "GMD Previsto" },
      ],
      pastos: [
        { key: "id", label: "ID" },
        { key: "nome", label: "Nome" },
        { key: "fazenda_nome", label: "Fazenda" },
        { key: "area_hectares", label: "Área (ha)" },
        { key: "tipo_forragem", label: "Forragem" },
        { key: "produtividade_kg_ha", label: "Produtividade (kg/ha)" },
      ],
      fazendas: [
        { key: "id", label: "ID" },
        { key: "nome", label: "Nome" },
        { key: "cidade", label: "Cidade" },
        { key: "estado", label: "Estado" },
        { key: "hectares", label: "Hectares" },
        { key: "atividade_principal", label: "Atividade Principal" },
      ],
      funcionarios: [
        { key: "id", label: "ID" },
        { key: "nome", label: "Nome" },
        { key: "cargo", label: "Cargo" },
        { key: "fazenda_nome", label: "Fazenda" },
        { key: "cpf", label: "CPF" },
        { key: "custo_hora", label: "Custo/hora (R$)" },
      ],
      maquinas: [
        { key: "id", label: "ID" },
        { key: "modelo", label: "Modelo" },
        { key: "fabricante", label: "Fabricante" },
        { key: "fazenda_nome", label: "Fazenda" },
        { key: "veiculos", label: "Veículos" },
        { key: "ano_fabricacao", label: "Ano" },
        { key: "custo_hora", label: "Custo/hora (R$)" },
        { key: "velocidade_media", label: "Vel. Média (km/h)" },
      ],
      talhoes: [
        { key: "id", label: "ID" },
        { key: "nome_codigo", label: "Nome/Código" },
        { key: "fazenda_nome", label: "Fazenda" },
        { key: "hectares", label: "Hectares" },
        { key: "cultura_atual", label: "Cultura Atual" },
        { key: "situacao", label: "Situação" },
        { key: "responsavel_nome", label: "Responsável" },
      ],
      culturas: [
        { key: "id", label: "ID" },
        { key: "nome", label: "Nome" },
        { key: "ciclo_dias", label: "Ciclo (dias)" },
        { key: "descricao", label: "Descrição" },
      ],
      plantios: [
        { key: "id", label: "ID" },
        { key: "fazenda_nome", label: "Fazenda" },
        { key: "cultura_nome", label: "Cultura" },
        { key: "safra_nome", label: "Safra" },
        { key: "talhao_nome", label: "Talhão" },
        { key: "area_hectares", label: "Área (ha)" },
        { key: "data_plantio", label: "Data Plantio" },
      ],
      safras: [
        { key: "id", label: "ID" },
        { key: "nome", label: "Nome" },
        { key: "data_inicio", label: "Início" },
        { key: "data_fim", label: "Fim" },
        { key: "ativa", label: "Ativa" },
      ],
      tipos_manejo: [
        { key: "id", label: "ID" },
        { key: "nome", label: "Nome" },
        { key: "descricao", label: "Descrição" },
        { key: "dose_padrao", label: "Dose Padrão" },
        { key: "unidade_medida", label: "Unidade" },
        { key: "carencia_dias", label: "Carência (dias)" },
      ],
      tipos_atividades: [
        { key: "id", label: "ID" },
        { key: "nome", label: "Nome" },
        { key: "tipo_principal_display", label: "Tipo Principal" },
      ],
      categorias_produtos: [
        { key: "id", label: "ID" },
        { key: "nome", label: "Nome" },
      ],
      subcategorias: [
        { key: "id", label: "ID" },
        { key: "nome", label: "Nome" },
        { key: "categoria_principal_nome", label: "Categoria" },
      ],
      itens_estoque: [
        { key: "id", label: "ID" },
        { key: "nome", label: "Nome" },
        { key: "tipo_display", label: "Tipo" },
        { key: "categoria_nome", label: "Categoria" },
        { key: "unidade_medida_sigla", label: "Unidade" },
        { key: "saldo_atual", label: "Saldo Atual" },
        { key: "custo_unitario", label: "Custo Unit. (R$)" },
        { key: "codigo_interno", label: "Cód. Interno" },
      ],
      locais_estoque: [
        { key: "id", label: "ID" },
        { key: "nome", label: "Nome" },
        { key: "descricao", label: "Descrição" },
      ],
      unidades_medida: [
        { key: "id", label: "ID" },
        { key: "sigla", label: "Sigla" },
        { key: "descricao", label: "Descrição" },
      ],
    };
    return configs[tipo] || null;
  };

  // ─── TÍTULO ──────────────────────────────────────────────────────────────────
  const getTituloRelatorio = () => {
    const titulos = {
      animais: "Relatório de Animais",
      lotes: "Relatório de Lotes",
      pastos: "Relatório de Pastos",
      tipos_manejo: "Relatório de Tipos de Manejo",
      culturas: "Relatório de Culturas",
      plantios: "Relatório de Plantios",
      safras: "Relatório de Safras",
      tipos_atividades: "Relatório de Tipos de Atividades",
      fazendas: "Relatório de Fazendas",
      funcionarios: "Relatório de Funcionários",
      maquinas: "Relatório de Máquinas",
      talhoes: "Relatório de Talhões",
      categorias_produtos: "Relatório de Categorias de Produtos",
      locais_estoque: "Relatório de Locais de Estoque",
      subcategorias: "Relatório de Subcategorias",
      unidades_medida: "Relatório de Unidades de Medida",
      itens_estoque: "Relatório de Itens de Estoque",
    };
    return titulos[tipo] || "Relatório de Cadastros";
  };

  // ─── BUSCAR DADOS ────────────────────────────────────────────────────────────
  const buscarDados = async () => {
    setCarregando(true);
    setErro("");
    try {
      const filtrosAtivos = {};
      Object.keys(filtros).forEach((key) => {
        const val = String(filtros[key] ?? "").trim();
        if (val !== "") filtrosAtivos[key] = val;
      });

      const response = await api.get(`/relatorios/${tipo}/`, {
        params: filtrosAtivos,
      });
      setDados(response.data);
      setShowModal(true);
    } catch (error) {
      console.error("Erro ao buscar dados:", error);
      setErro("Erro ao carregar o relatório. Verifique os filtros e tente novamente.");
    } finally {
      setCarregando(false);
    }
  };

  // ─── UTILITÁRIO: formatar valor para exibição ────────────────────────────────
  const formatarValor = (val) => {
    if (val === null || val === undefined || val === "") return "-";
    if (typeof val === "boolean") return val ? "Sim" : "Não";
    if (typeof val === "string") {
      // ISO datetime: "2024-01-15T10:30:00..." → "15/01/2024"
      if (/^\d{4}-\d{2}-\d{2}T/.test(val)) {
        const [datePart] = val.split("T");
        const [ano, mes, dia] = datePart.split("-");
        return `${dia}/${mes}/${ano}`;
      }
      // ISO date: "2024-01-15" → "15/01/2024"
      // (split evita problemas de fuso horário que new Date() causaria)
      if (/^\d{4}-\d{2}-\d{2}$/.test(val)) {
        const [ano, mes, dia] = val.split("-");
        return `${dia}/${mes}/${ano}`;
      }
    }
    return String(val);
  };

  // ─── EXPORTAR EXCEL ──────────────────────────────────────────────────────────
  const exportarExcel = () => {
    if (!dados || dados.length === 0) {
      alert("⚠️ Não há dados para exportar!");
      return;
    }

    const colunasConfig = getColunasConfig();

    const dadosParaExportar = colunasConfig
      ? dados.map((item) => {
          const row = {};
          colunasConfig.forEach((col) => {
            row[col.label] = formatarValor(item[col.key]);
          });
          return row;
        })
      : dados;

    const worksheet = XLSX.utils.json_to_sheet(dadosParaExportar);
    const workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, worksheet, "Relatório");
    XLSX.writeFile(
      workbook,
      `${getTituloRelatorio().replace(/[^a-z0-9]/gi, "_")}.xlsx`,
    );
  };

  // ─── EXPORTAR PDF ────────────────────────────────────────────────────────────
  const exportarPDF = async () => {
    if (!dados || dados.length === 0) {
      alert("⚠️ Não há dados para exportar!");
      return;
    }

    const colunasConfig = getColunasConfig();
    const colunas = colunasConfig
      ? colunasConfig
      : Object.keys(dados[0]).map((k) => ({
          key: k,
          label: k.replace(/_/g, " ").toUpperCase(),
        }));

    await exportarRelatorioPDF({
      titulo: getTituloRelatorio(),
      colunas,
      dados,
      formatarValor: (valor) => formatarValor(valor),
      columnStyles: { 0: { cellWidth: 12, halign: "center" } },
    });
  };

  // ─── IMPRIMIR ────────────────────────────────────────────────────────────────
  const imprimir = () => {
    if (!dados || dados.length === 0) {
      alert("⚠️ Não há dados para imprimir!");
      return;
    }

    const colunasConfig = getColunasConfig();
    const printWindow = window.open("", "_blank");

    const headers = colunasConfig
      ? colunasConfig.map((c) => `<th>${c.label}</th>`).join("")
      : Object.keys(dados[0] || {})
          .map((k) => `<th>${k.replace(/_/g, " ").toUpperCase()}</th>`)
          .join("");

    const rows = dados
      .map((item) => {
        const cells = colunasConfig
          ? colunasConfig
              .map((c) => `<td>${formatarValor(item[c.key])}</td>`)
              .join("")
          : Object.values(item)
              .map((v) => `<td>${formatarValor(v)}</td>`)
              .join("");
        return `<tr>${cells}</tr>`;
      })
      .join("");

    printWindow.document.write(`
      <html>
        <head>
          <title>${getTituloRelatorio()}</title>
          <style>
            body { font-family: Arial, sans-serif; margin: 20px; }
            h1 { color: #333; }
            table { width: 100%; border-collapse: collapse; margin-top: 20px; }
            th, td { border: 1px solid #ddd; padding: 8px; text-align: left; font-size: 12px; }
            th { background-color: #f2f2f2; font-weight: bold; }
            tr:nth-child(even) { background-color: #f9f9f9; }
            .footer { margin-top: 20px; font-size: 11px; color: #666; text-align: center; }
            @media print { body { margin: 0; padding: 15px; } .no-print { display: none; } }
          </style>
        </head>
        <body>
          <h1>${getTituloRelatorio()}</h1>
          <p><strong>Gerado em:</strong> ${new Date().toLocaleString("pt-BR")}</p>
          <p><strong>Total de registros:</strong> ${dados.length}</p>
          <table>
            <thead><tr>${headers}</tr></thead>
            <tbody>${rows}</tbody>
          </table>
          <div class="footer">Sistema de Gestão Agropecuária — Relatório gerado automaticamente</div>
          <script>
            window.onload = () => { window.print(); setTimeout(() => window.close(), 100); }
          <\/script>
        </body>
      </html>
    `);
    printWindow.document.close();
  };

  // ─── RENDER ──────────────────────────────────────────────────────────────────
  return (
    <>
      {/* Conteúdo principal */}
      <div className="min-h-screen bg-gray-50 p-4 md:p-8">
        <div className="max-w-7xl mx-auto">
          <CabecalhoRelatorio
            icone={BiSolidReport}
            titulo="Relatórios de Cadastros"
            descricao="Selecione o tipo de cadastro e aplique os filtros desejados para gerar seu relatório"
          />

          {/* Filtros */}
          <Cartao titulo="Filtros" icone={FiFilter} className="mb-6">
            {/* Tipo de Relatório */}
            <div className="mb-6">
              <label className="block text-sm font-semibold text-gray-700 mb-2">
                Tipo de Relatório
              </label>
              <select
                value={tipo}
                onChange={(e) => {
                  setTipo(e.target.value);
                  limparFiltros();
                  setDados([]);
                  setErro("");
                }}
                className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-brand-green focus:border-transparent outline-none transition bg-white"
              >
                <optgroup label="Cadastros do Sistema">
                  <option value="animais">Animais</option>
                  <option value="lotes">Lotes</option>
                  <option value="pastos">Pastos</option>
                  <option value="fazendas">Fazendas</option>
                  <option value="funcionarios">Funcionários</option>
                  <option value="maquinas">Máquinas</option>
                  <option value="talhoes">Talhões</option>
                </optgroup>
                <optgroup label="Gestão de Estoque">
                  <option value="categorias_produtos">Categorias de Produtos</option>
                  <option value="subcategorias">Subcategorias</option>
                  <option value="itens_estoque">Itens de Estoque</option>
                  <option value="locais_estoque">Locais de Estoque</option>
                  <option value="unidades_medida">Unidades de Medida</option>
                </optgroup>
                <optgroup label="Gestão Agrícola">
                  <option value="culturas">Culturas</option>
                  <option value="plantios">Plantios</option>
                  <option value="safras">Safras</option>
                  <option value="tipos_manejo">Tipos de Manejo</option>
                  <option value="tipos_atividades">Tipos de Atividades</option>
                </optgroup>
              </select>
            </div>

            {/* Filtros Dinâmicos */}
            <div className="mb-6">
              <label className="block text-sm font-semibold text-gray-700 mb-2">
                Filtros
              </label>
              {getFiltrosPorTipo()}
            </div>

            {erro && (
              <div className="mb-4 flex items-center gap-2 bg-red-50 border border-red-200 text-red-700 text-sm rounded-lg px-4 py-3">
                <FiAlertCircle size={18} className="shrink-0" />
                <span>{erro}</span>
              </div>
            )}

            {/* Botões */}
            <div className="flex gap-3">
              <BotaoRelatorio
                variante="primario"
                onClick={buscarDados}
                carregando={carregando}
                className="flex-1"
              >
                Gerar Relatório
              </BotaoRelatorio>
              <BotaoRelatorio variante="secundario" onClick={limparFiltros}>
                Limpar Filtros
              </BotaoRelatorio>
            </div>
          </Cartao>
        </div>
      </div>

      {/* Modal */}
      {showModal && (
        <div
          className="fixed inset-0 z-[9999] flex items-center justify-center p-4"
          style={{
            position: "fixed",
            top: 0,
            left: 0,
            right: 0,
            bottom: 0,
            backgroundColor: "rgba(0,0,0,0.5)",
            zIndex: 9999,
            overflow: "auto",
          }}
          onClick={() => setShowModal(false)}
        >
          <div
            className="bg-white rounded-2xl shadow-2xl w-full max-w-7xl my-8 flex flex-col"
            style={{ zIndex: 10000, maxHeight: "calc(100vh - 4rem)" }}
            onClick={(e) => e.stopPropagation()}
          >
            {/* Modal Header */}
            <div className="flex items-center justify-between p-6 border-b border-gray-200 flex-shrink-0">
              <h3 className="text-xl font-bold text-gray-800 flex items-center gap-2">
                <BiSolidReport size={22} className="text-brand-green" />
                {getTituloRelatorio()}
              </h3>
              <button
                onClick={() => setShowModal(false)}
                className="w-8 h-8 bg-gray-100 hover:bg-gray-200 rounded-lg flex items-center justify-center transition flex-shrink-0"
              >
                <FiX size={18} className="text-gray-600" />
              </button>
            </div>

            {/* Modal Actions */}
            <div className="p-6 border-b border-gray-200 bg-gray-50 flex flex-wrap gap-3 flex-shrink-0">
              <BotaoRelatorio variante="excel" onClick={exportarExcel}>
                Exportar para Excel
              </BotaoRelatorio>
              <BotaoRelatorio variante="pdf" onClick={exportarPDF}>
                Exportar para PDF
              </BotaoRelatorio>
              <BotaoRelatorio variante="imprimir" onClick={imprimir}>
                Imprimir
              </BotaoRelatorio>
            </div>

            {/* Modal Body */}
            <div className="flex-1 overflow-auto p-6" style={{ minHeight: 0 }}>
              {/* Info */}
              <div className="bg-emerald-50 border border-emerald-200 rounded-lg p-4 mb-6 flex flex-wrap justify-between items-center gap-3">
                <div className="flex items-center gap-2">
                  <span className="text-emerald-800 font-medium">
                    Total de registros:
                  </span>
                  <span className="text-emerald-900 font-bold text-lg">
                    {dados.length}
                  </span>
                </div>
                <span className="text-emerald-800 text-sm">
                  Gerado em: {new Date().toLocaleString("pt-BR")}
                </span>
              </div>

              {/* Tabela */}
              {dados.length > 0 ? (
                <div className="overflow-x-auto rounded-lg border border-gray-200" style={{ maxWidth: "100%" }}>
                  <div style={{ minWidth: "max-content" }}>
                    <table className="w-full border-collapse">
                      <thead>
                        <tr className="bg-gray-50 border-b border-gray-200 sticky top-0">
                          {(getColunasConfig() || Object.keys(dados[0]).map((k) => ({ key: k, label: k.replace(/_/g, " ").toUpperCase() }))).map(
                            (col) => (
                              <th
                                key={col.key}
                                className="px-4 py-3 text-left text-xs font-semibold text-gray-500 uppercase tracking-wide whitespace-nowrap"
                              >
                                {col.label}
                              </th>
                            ),
                          )}
                        </tr>
                      </thead>
                      <tbody>
                        {dados.map((item, index) => (
                          <tr
                            key={index}
                            className="border-b border-gray-100 hover:bg-gray-50 transition"
                          >
                            {(getColunasConfig() || Object.keys(dados[0]).map((k) => ({ key: k, label: k }))).map(
                              (col) => (
                                <td
                                  key={col.key}
                                  className="px-4 py-3 text-sm text-gray-600 whitespace-nowrap"
                                >
                                  {formatarValor(item[col.key])}
                                </td>
                              ),
                            )}
                          </tr>
                        ))}
                      </tbody>
                    </table>
                  </div>
                </div>
              ) : (
                <EstadoVazio descricao="Ajuste os filtros selecionados e tente novamente." />
              )}
            </div>

            {/* Modal Footer */}
            <div className="p-6 border-t border-gray-200 bg-gray-50 flex justify-end flex-shrink-0">
              <BotaoRelatorio variante="secundario" onClick={() => setShowModal(false)}>
                Fechar
              </BotaoRelatorio>
            </div>
          </div>
        </div>
      )}
    </>
  );
};

export default RelatorioCadastros;
